import { createSlice } from "@reduxjs/toolkit";
import { signInUser } from "../Components/Utility/Auth";

const user = signInUser();

export const productPriceListSlice = createSlice({
  name: "priceList",
  initialState: [],
  reducers: {
    productPriceList: (state, action) => {
      return action.payload || [];
    },
    addProductPrice: (state, action) => {
      const user = signInUser();
      const defaultWh =
        action.payload?.warehouse ||
        (typeof user?.warehouse === "object"
          ? user?.warehouse?._id
          : user?.warehouse) ||
        "";
      const newPrice = {
        supplier: "",
        warehouse: defaultWh,
        tp: 0,
        mrp: 0,
        stock: 0,
        status: "active",
      };
      state.push(newPrice);
    },
    handleSupplier: (state, action) => {
      const { supplier, index } = action.payload;
      if (state[index]) {
        state[index].supplier = supplier;
      }
    },
    handleWarehouse: (state, action) => {
      const { warehouse, index } = action.payload;
      if (state[index]) {
        state[index].warehouse = warehouse;
      }
    },
    handleMrp: (state, action) => {
      const { mrp, index } = action.payload;
      if (state[index]) {
        state[index].mrp = mrp === "" ? "" : Number(mrp);
      }
    },
    handleTp: (state, action) => {
      const { tp, index } = action.payload;
      if (state[index]) {
        state[index].tp = tp === "" ? "" : Number(tp);
      }
    },

    handleRemove: (state, action) => {
      const index = action.payload;
      if (index >= 0 && index < state.length) {
        state.splice(index, 1);
      }
    },
    handleStatus: (state, action) => {},
  },
});

export const {
  productPriceList,
  addProductPrice,
  handleSupplier,
  handleWarehouse,
  handleMrp,
  handleTp,
  handleRemove,
} = productPriceListSlice.actions;
export const productPriceListReducer = productPriceListSlice.reducer;
